import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { StaticImage } from 'gatsby-plugin-image';
import BulitIcon from '../../kit/icons/BulitIcon';
import styles from './styles';
import WalletIcon from '../../kit/icons/WalletIcon';
import CalendarDeskIcon from '../../kit/icons/CalendarDeskIcon';
import PaymentIcon from '../../kit/icons/PaymentIcon';
import DiscountIcon from '../../kit/icons/DiscountIcon';
import PresentIcon from '../../kit/icons/PresentIcon';
import StarIcon from '../../kit/icons/StarIcon';
import ComputerIcon from '../../kit/icons/ComputerIcon';

function PointWithIcon({
  children,
  icon = 'default',
  iconColor,
  size = 'default',
}) {
  const [currentIcon, setCurrentIcon] = useState();

  useEffect(() => {
    switch (icon) {
      case 'fire': {
        setCurrentIcon(<StaticImage src="./emojies/fire.png" alt="fire" />);
        return;
      }
      case 'voltage': {
        setCurrentIcon(
          <StaticImage src="./emojies/voltage.png" alt="voltage" />,
        );
        return;
      }
      case 'gift': {
        setCurrentIcon(<StaticImage src="./emojies/gift.png" alt="gift" />);
        return;
      }
      case 'present': {
        setCurrentIcon(<PresentIcon sx={styles[`icon_${icon}`]} />);
        return;
      }
      case 'wallet': {
        setCurrentIcon(<WalletIcon sx={styles[`icon_${icon}`]} />);
        return;
      }
      case 'calendar': {
        setCurrentIcon(<CalendarDeskIcon sx={styles[`icon_${icon}`]} />);
        return;
      }
      case 'discount': {
        setCurrentIcon(<DiscountIcon sx={styles[`icon_${icon}`]} />);
        return;
      }
      case 'payment': {
        setCurrentIcon(<PaymentIcon sx={styles[`icon_${icon}`]} />);
        return;
      }
      case 'star': {
        setCurrentIcon(<StarIcon sx={styles[`icon_${icon}`]} />);
        return;
      }
      case 'computer': {
        setCurrentIcon(<ComputerIcon sx={styles[`icon_${icon}`]} />);
        return;
      }
      default: {
        setCurrentIcon(<BulitIcon />);
      }
    }
  }, [icon]);

  return (
    <Box sx={styles.item}>
      <Box
        sx={{
          ...styles[`icon_${icon}`],
          ...styles[`icon_list_size_${size}`],
          ...styles['icon_wrapper'],
        }}
        color={iconColor || '#4520AB'}
      >
        {currentIcon}
      </Box>
      {children}
    </Box>
  );
}

export default PointWithIcon;
